<div *ngIf="!loading">
  <input id="fieldsearch" [(ngModel)]="search" class="form-control filter-input" style="margin-bottom:20px;" placeholder="Search by Field Name" />

  <form>
    <div class="form-row">

      <div class="form-group col-md-6">
        <div><button class="btn btn-outline-success" *ngIf="(this.mode != 0 && this.mode.toString() != 'editMode')" [disabled]="fieldsAva.length == 0" (click)="addAll()">Add All</button></div>
        <label for="avaTable" class="form-control-label">Available Fields {{fieldsAva.length}}<i class="fas fa-sort" (click)="orderList('fieldName','fa')"></i></label>
        <div style="max-height:500px;overflow-y:scroll;" *ngIf="fieldsAva.length > 0 ">
          <table class=" table table-hover" id="avaTable" name="avaTable">
            <tr *ngFor="let fa of fieldsAva | fieldsACLFilter: search: dummbyValue1;let i = index">
              <td>{{fa.fieldName}} </td>
              <td style="width:60px;"><button type="button" class="btn btn-outline-success"  (click)="changeFieldAssoc(fa,true , i)"><i class="{{fa.lockIcon}}"></i></button></td>
            </tr>
          </table>
        </div>
        <div *ngIf="fieldsAva.length == 0" class="alert alert-info" role="alert">
          No Fields available.
        </div>
      </div>

      <div class="form-group col-md-6">
        <div><button class="btn btn-outline-danger" *ngIf="(this.mode != 0 && this.mode.toString() != 'editMode')" [disabled]="fieldsOwned.length == 0" (click)="removeAll()">Remove All</button></div>
        <label class="form-control-label" for="ownedTable">Visible Fields {{fieldsOwned.length}}<i class="fas fa-sort" (click)="orderList('fieldName','fo')"></i></label>
        <div style="max-height:500px;overflow-y:scroll;" *ngIf="fieldsOwned.length > 0">
          <table class=" table table-hover" id="ownedTable" name="ownedTable">
            <tr *ngFor="let fo of fieldsOwned | fieldsACLFilter: search: dummbyValue2;let i = index" >

              <td>{{fo.fieldName}} </td>
              <td style="width:60px;"><button type="button" class="btn btn-outline-danger"  (click)="changeFieldAssoc(fo,false , i)"><i class='{{fo.lockIcon}}'></i></button></td>
            </tr>
          </table>
        </div>
        <div *ngIf="fieldsOwned.length == 0" class="alert alert-info" role="alert">
          No Fields associated.
        </div>
      </div>
    </div>

  </form>
</div>

<div style="width:100%">
  <div *ngIf="loading" class="spinner-border" style="width: 3rem; height: 3rem; display:flex;margin-left:auto;margin-right:auto;" role="status"></div>
</div>
